// src/LandingPage.js
import React, { useState } from "react";
import { Link } from 'react-router-dom'
import { Button, Popup, NavBar } from "antd-mobile";
import { Modal } from "antd";
import { Helmet } from "react-helmet";
import Header from "../components/visual/header";
import Footer from "../components/visual/footer";
import PDFViewer from "../components/visual/pdf-viewer-4";
import AmazonReviewsBadge from "../components/visual/amazon-badge";
import { FE_BASE_URI } from "../constants/const";

import agendaBG from "../assets/portada-agenda-1.jpg";

const LandingPage = () => {
  const [modalVisible, setModalVisible] = useState(false); //Desktop
  const [isDrawerOpen, setIsDrawerOpen] = useState(false); // movil

  const closeModal = () => {
    setModalVisible(false);
  };

  return (
    <>
      <Helmet>
        <title>littlecoders.dev. Aprende Python mientras organizas tu día</title>
        <meta name="description" content="littlecoders.dev. Aprende Python mientras organizas tu día. La agenda escolar interactiva ideal para niños y estudiantes." />
        <meta name="keywords" content="aprender a programar niños, libros programación para niños, agenda escolar 2026/2026, agenda escolar python, regalo educativo programación" />
        <meta property="og:title" content="littlecoders.dev. Aprende Python mientras organizas tu día" />
        <meta property="og:description" content="littlecoders.dev. Aprende Python mientras organizas tu día. La agenda escolar interactiva ideal para niños y estudiantes." />
        <meta property="og:image" content="https://littlecoders.dev/portada.png" />
      </Helmet>

      <Header />

      {/* Hero Section */}
      <div
        style={{
          backgroundColor: "#eef3ff",
          padding: "100px 20px 50px 20px", // Increased top padding to account for fixed header
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <div className="container" style={{ display: "flex", flexWrap: "wrap", alignItems: "center", maxWidth: "1000px" }}>

          <div className="text-section" style={{ flex: "1 1 400px", padding: "20px" }}>
            <h1 style={{ fontSize: "2.5rem", color: "#333", fontWeight: "900", lineHeight: "1.2", marginBottom: "20px" }}>
              La agenda en papel para estudiantes que quieren dominar <span style={{ color: "#5B88FA" }}>Python</span>.
            </h1>
            <p style={{ fontSize: "1.2rem", color: "#555", marginBottom: "30px", lineHeight: "1.5" }}>
              Organiza tus tareas académicas mientras descubres paso a paso la programación.
              Menos pantallas pasivas, más horas de creatividad.
            </p>

            <div>
              <a
                href="/redirect?url=https://www.amazon.es/dp/B0GDQDV864"
                target="_blank"
                rel="noreferrer"
                style={{
                  display: "inline-block",
                  backgroundColor: "#FFD814",
                  color: "#111",
                  padding: "15px 30px",
                  borderRadius: "30px",
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                  textDecoration: "none",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                  marginBottom: "15px",
                  marginRight: "10px"
                }}
              >
                <i className="fa-brands fa-amazon me-2"></i>
                Comprar Agenda 26/27
              </a>

              <a
                href="/redirect?url=https://www.amazon.es/dp/B0DR7BGF7L"
                target="_blank"
                rel="noreferrer"
                style={{
                  display: "inline-block",
                  backgroundColor: "#f8f9fa",
                  color: "#111",
                  padding: "10px 20px",
                  border: "1px solid #ddd",
                  borderRadius: "30px",
                  fontSize: "1rem",
                  fontWeight: "bold",
                  textDecoration: "none",
                  marginBottom: "15px"
                }}
              >
                <i className="fa-brands fa-amazon me-2"></i>
                Edición 25/26
              </a>
            </div>

            <div style={{ marginTop: "10px" }}>
              <AmazonReviewsBadge asin="B0GDQGD3CP" unstyled={false} />
            </div>
          </div>

          <div className="image-section" style={{ flex: "1 1 300px", textAlign: "center", padding: "20px" }}>
            <img
              src={agendaBG}
              alt="Agenda Escolar Python 26/27"
              style={{
                width: "100%",
                maxWidth: "350px",
                borderRadius: "15px",
                transform: "rotate(5deg)",
                boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
                transition: "transform 0.3s ease"
              }}
              onMouseOver={(e) => e.currentTarget.style.transform = "rotate(0deg) scale(1.05)"}
              onMouseOut={(e) => e.currentTarget.style.transform = "rotate(5deg) scale(1)"}
            />
          </div>

        </div>
      </div>

      {/* What's Inside Section */}
      <div style={{ backgroundColor: "#fff", padding: "60px 20px" }}>
        <div className="container" style={{ maxWidth: "1000px", margin: "0 auto" }}>

          <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", marginBottom: "60px" }}>
            <div style={{ flex: "1 1 400px", padding: "20px" }}>
              <h2 style={{ fontSize: "2rem", color: "#5B88FA", fontWeight: "bold", marginBottom: "20px" }}>
                Simula el aspecto de VS Code
              </h2>
              <p style={{ fontSize: "1.2rem", color: "#666", lineHeight: "1.6" }}>
                El interior de la agenda simula ser <strong>Visual Studio Code</strong>.
                Cada semana incluye un ejercicio de Python con un <strong>código QR</strong> para ejecutarlo fácilmente en la web de littlecoders.dev.
              </p>
              <p style={{ fontSize: "1.2rem", color: "#666", lineHeight: "1.6", fontWeight: "bold" }}>
                Sin instalaciones. Sin complicaciones. Solo escanea y empieza a programar.
              </p>
            </div>
            <div style={{ flex: "1 1 400px", padding: "20px", textAlign: "center" }}>
              <div style={{ backgroundColor: "#1e1e1e", borderRadius: "10px", padding: "20px", color: "#d4d4d4", border: "1px solid #3c3c3c", fontFamily: "monospace", textAlign: "left", boxShadow: "0 10px 30px rgba(0,0,0,0.15)", fontSize: "0.95rem", lineHeight: "1.5" }}>
                <span style={{ color: "#6a9955" }}># hola-mundo.py</span><br />
                <span style={{ color: "#6a9955" }}># Este programa imprime un mensaje en la consola.</span><br />
                <span style={{ color: "#dcdcaa" }}>print</span>(<span style={{ color: "#ce9178" }}>"¡Hola, Mundo!"</span>)
              </div>
            </div>
          </div>

          <h2 style={{ textAlign: "center", fontSize: "2rem", color: "#333", marginBottom: "40px", fontWeight: "bold" }}>
            ¿Qué encontrarás dentro?
          </h2>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "20px" }}>
            <div style={{ backgroundColor: "#f8f9fa", padding: "25px", borderRadius: "10px", borderLeft: "5px solid #FA824C" }}>
              <h4 style={{ fontWeight: "bold", marginBottom: "10px" }}>✅ Curso Completo</h4>
              <p style={{ margin: 0, color: "#666" }}>Calendario semanal de septiembre a junio.</p>
            </div>
            <div style={{ backgroundColor: "#f8f9fa", padding: "25px", borderRadius: "10px", borderLeft: "5px solid #FA824C" }}>
              <h4 style={{ fontWeight: "bold", marginBottom: "10px" }}>✅ 40 Retos de nivel</h4>
              <p style={{ margin: 0, color: "#666" }}>Retos de programación en Python, de básico a avanzado.</p>
            </div>
            <div style={{ backgroundColor: "#f8f9fa", padding: "25px", borderRadius: "10px", borderLeft: "5px solid #FA824C" }}>
              <h4 style={{ fontWeight: "bold", marginBottom: "10px" }}>✅ Códigos QR online</h4>
              <p style={{ margin: 0, color: "#666" }}>Para practicar online instantáneamente desde móvil o PC.</p>
            </div>
            <div style={{ backgroundColor: "#f8f9fa", padding: "25px", borderRadius: "10px", borderLeft: "5px solid #FA824C" }}>
              <h4 style={{ fontWeight: "bold", marginBottom: "10px" }}>✅ Backlog de tareas</h4>
              <p style={{ margin: 0, color: "#666" }}>Metodología ágil para mejorar tu organización personal.</p>
            </div>
            <div style={{ backgroundColor: "#f8f9fa", padding: "25px", borderRadius: "10px", borderLeft: "5px solid #FA824C" }}>
              <h4 style={{ fontWeight: "bold", marginBottom: "10px" }}>✅ Sello Profesional</h4>
              <p style={{ margin: 0, color: "#666" }}>Diseñada por un ingeniero informático con más de 20 años de experiencia.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Target Audience Section */}
      <div style={{ backgroundColor: "#f8f9fa", padding: "60px 20px" }}>
        <div className="container" style={{ maxWidth: "900px", margin: "0 auto", textAlign: "center" }}>
          <h2 style={{ fontSize: "2rem", color: "#5B88FA", fontWeight: "bold", marginBottom: "40px" }}>
            ¿Para quién es esta agenda?
          </h2>

          <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "30px", marginBottom: "40px" }}>
            <div style={{ width: "250px" }}>
              <div style={{ fontSize: "3rem", marginBottom: "15px" }}>💻</div>
              <h4 style={{ fontWeight: "bold" }}>Estudiantes</h4>
              <p style={{ color: "#666" }}>De secundaria o primaria avanzada con curiosidad por la tecnología.</p>
            </div>
            <div style={{ width: "250px" }}>
              <div style={{ fontSize: "3rem", marginBottom: "15px" }}>🎁</div>
              <h4 style={{ fontWeight: "bold" }}>Padres y Madres</h4>
              <p style={{ color: "#666" }}>Que buscan un regalo útil. Perfecta para comuniones o inicio de curso.</p>
            </div>
            <div style={{ width: "250px" }}>
              <div style={{ fontSize: "3rem", marginBottom: "15px" }}>👩‍🏫</div>
              <h4 style={{ fontWeight: "bold" }}>Profesores</h4>
              <p style={{ color: "#666" }}>De Tecnología que quieren un recurso complementario y estructurado.</p>
            </div>
          </div>

          <div style={{ backgroundColor: "#FFD814", padding: "30px", borderRadius: "15px", color: "#111", boxShadow: "0 10px 20px rgba(0,0,0,0.1)" }}>
            <h3 style={{ fontWeight: "bold", marginBottom: "15px", fontSize: "1.5rem" }}>
              Aprende a pensar como un programador.
            </h3>
            <p style={{ fontSize: "1.2rem", margin: 0 }}>
              Organízate. Crea. Mejora. Todo desde tu propia agenda física conectada a la web.
            </p>
          </div>

        </div>
      </div>

      {/* Preview Section */}
      <div style={{ backgroundColor: "#FA824C", padding: "60px 20px", color: "white", textAlign: "center" }}>
        <h2 style={{ fontSize: "2.2rem", fontWeight: "bold", marginBottom: "20px" }}>
          ¿Quieres ver cómo es por dentro?
        </h2>
        <p style={{ fontSize: "1.2rem", marginBottom: "30px", maxWidth: "600px", margin: "0 auto 30px auto" }}>
          Ojea la estructura de los días y los ejercicios de Python integrados antes de comprar en Amazon.
        </p>
        <div className="d-none d-md-block">
          <Button
            size="large"
            style={{
              backgroundColor: "white",
              color: "#FA824C",
              fontWeight: "bold",
              border: "none",
              borderRadius: "25px",
              padding: "10px 30px",
              fontSize: "1.1rem",
              cursor: "pointer"
            }}
            onClick={() => setModalVisible(true)}
          >
            <i className="fa-solid fa-book-open me-2"></i> Ver Interior de la Agenda
          </Button>
        </div>
        <div className="d-md-none">
          <Button
            size="large"
            style={{
              backgroundColor: "white",
              color: "#FA824C",
              fontWeight: "bold",
              border: "none",
              borderRadius: "25px",
              padding: "10px 30px",
              fontSize: "1.1rem",
              cursor: "pointer"
            }}
            onClick={() => setIsDrawerOpen(true)}
          >
            <i className="fa-solid fa-book-open me-2"></i> Ver Interior de la Agenda
          </Button>
        </div>
      </div>

      {/* Teachers Section */}
      <div className="mt-5" style={{ backgroundColor: "#4F46E5", padding: "80px 20px", textAlign: "center", color: "white" }}>
        <h2 style={{ fontSize: "2.5rem", color: "#ffffff", marginBottom: "20px", fontWeight: "bold" }}>
          👩‍🏫 ¿Eres profesor/a de Tecnología o Informática?
        </h2>
        <p style={{ fontSize: "1.2rem", color: "#E0E7FF", maxWidth: "800px", margin: "0 auto 40px auto", lineHeight: "1.6" }}>
          Transforma la forma en que tus alumnos aprenden a programar. Lleva Python a tu aula de una manera súper original: de forma física mediante su agenda escolar y conectando con nuestra web. Disponen del complemento perfecto para alejarlos de distracciones.
        </p>
        <Link
          to="/teachers"
          style={{
            display: "inline-block",
            backgroundColor: "#ffffff",
            color: "#4F46E5",
            fontWeight: "bold",
            textDecoration: "none",
            fontSize: "1.2rem",
            padding: "15px 40px",
            borderRadius: "30px",
            boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
            transition: "transform 0.2s"
          }}
          onMouseOver={(e) => e.target.style.transform = "scale(1.05)"}
          onMouseOut={(e) => e.target.style.transform = "scale(1)"}
        >
          Descubre los recursos para docentes
        </Link>
      </div>

      {/* Footer */}
      <Footer />

      {/* Modals for PDF Viewer */}
      <Modal open={modalVisible} onCancel={closeModal} footer={null}
        style={{
          top: 0,
          padding: 0,
          height: '99vh',
          maxWidth: '100vw',
        }}
        bodyStyle={{
          height: 'calc(100vh - 50px)',
          overflowY: 'auto',
        }}>
        <div>
          <PDFViewer url={FE_BASE_URI + "preview2425.pdf"} />
        </div>
      </Modal>

      <Popup
        visible={isDrawerOpen}
        getContainer={false} // para que funcione en mobile
        onMaskClick={() => {
          setIsDrawerOpen(false);
        }}
        bodyStyle={{ width: "100%" }}
        position="left"
      >
        <NavBar
          onBack={() => {
            setIsDrawerOpen(false);
          }}
          className="back-bar"
        >
          Interior de la Agenda
        </NavBar>
        <div className="pt-1">
          <PDFViewer url={FE_BASE_URI + "preview2425.pdf"} />
        </div>
      </Popup>
    </>
  );
};

export default LandingPage;
